export default __webpack_public_path__ + "static/media/Screenshot454.84840d1e.png";